import en from "../translations/en.json";
import ka from "../translations/ka.json";

/**
 * Uploads the server's nudity check refused (422, code "nudity_detected"). The server
 * says why in English; the app says it in the reader's language.
 * @see mintly-back/src/middleware/nudityFilter.js
 */

const isRefused = (data) => data?.code === "nudity_detected";

/** The refusal in the reader's language, read outside React (the axios interceptor). */
function refusalText(kind) {
  let lang = "en";
  try {
    lang = localStorage.getItem("language") === "ka" ? "ka" : "en";
  } catch {
    /* default to English */
  }
  const key = kind === "video" ? "nudityBlockedVideo" : "nudityBlockedImage";
  return (lang === "ka" ? ka : en).uploads?.[key] || en.uploads[key];
}

/** Put the reader's words on a refused upload's error, wherever a caller reads them. */
export function translateRefusedUpload(error) {
  const data = error?.response?.data;
  if (!isRefused(data)) return;
  const text = refusalText(data.kind);
  data.message = text;
  error.message = text;
}

/**
 * Why an upload was refused, if the nudity check refused it; null otherwise. For callers
 * that show their own "upload failed" — the reason matters more here.
 */
export function refusedUploadMessage(error) {
  const data = error?.response?.data || error;
  return isRefused(data) ? data.message : null;
}
